<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="$emit('closeModal')">
          <div class="row">
            <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
              <div class="modal-container" @click.stop>
  
                <div class="modal-header row" style="justify-content: flex-end;">
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
  
                <div class="modal-body">
                  <h2 class="title">Tambah Harga Sparepart</h2>
                  <form>
                    <div class="row row-space">
                      <div class="col-12">
                        <div class="input-group">
                          <label class="label">Sparepart<span style="color: red;">*</span></label>
                          <MultiSelect
                            v-if="options.sparepart"
                            v-model="form.sparepart_id"
                            :options="options.sparepart.map(x => x.id)"
                            :custom-label="opt => options.sparepart.find(x => x.id == opt).sparepart_variants.name"
                            :allow-empty="false"
                            placeholder="Pilih Sparepart"
                          ></MultiSelect>
                        </div>
                      </div>
                    </div>
                    <div class="row row-space" v-for="(cat , index) in category">
                      <div class="col-xs-12 col-md-6 mt-auto mb-auto">
                        <div class="input-group ">
                          <label class="label">{{index + 1}}. <span class="ml-4">{{cat.name}}</span></label>
                          <!-- <input class="input--style-4" type="text" v-model="form.price" placeholder="Ketik Harga"> -->
                        </div>
                      </div>
                      <div class="col-xs-12 col-md-6">
                        <div class="input-group">
                          <label class="label">Harga<span style="color: red;">*</span></label>
                          <input class="input--style-4" type="text" v-model="cat.price" placeholder="Ketik Harga">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col mt-5" style="text-align: center">
                        <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                        <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Buat</button>
                      </div>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
  </template>
  
  <script>
    import MultiSelect from 'vue-multiselect';
  
    export default {
      data () {
        return {
          options : {
            sparepart : null
          },
          rangeConfig: {
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          selected: {
            brand_id : ''
          },
          form : {
            insurance_company_id : this.insuranceCompanyId,
            sparepart_id : '',
            insurance_car_type_id : null,
            price : '',
          }
        }
      },
      props : ['insuranceCompanyId', 'category'],
      components:{
        MultiSelect,
      },
      mounted () {
        this.loadSparepart()
      },
      watch : {
        'form.sparepart_id' : function() {
          for(var i = 0 ; i < this.category.length ; i++) {
            this.category[i].sparepart_id = this.form.sparepart_id
          }
        }
      },
      methods : {
        loadSparepart () {
          this.options.sparepart = null
          let data = []
          this.$http.get(`/api/v1/masterData/sparepart?pagination=false`)
          .then((resp) => {
            let sparepartMaster = resp.data.data
            console.log(sparepartMaster)
            for(var i = 0 ; i < sparepartMaster.length ; i++) {
              sparepartMaster[i].name = sparepartMaster[i].sparepart_variants.name
              if(sparepartMaster[i].sparepart_variants.sparepart_type_id == 1) {
                data.push(sparepartMaster[i])
              }
            }
            this.options.sparepart = data
            console.log(data)
          })
          .catch((err) => {console.log(err)})
        },
        validateForm(){
          var valid = true;
          var error = [];
  
  
          if(this.form.sparepart_id == '' || this.form.sparepart_id == null){//Sparepart [Required]
            valid = false;
            error.push('Sparepart wajib diisi');
          }

          if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
          else return valid;
        },
        async submitForm(){
          let vm = this;
          console.log('hello')
          if(vm.validateForm()){
            for(var i = 0 ; i < this.category.length ; i++) {
              let obj = Object.assign({} , this.form)

              obj.price = this.category[i].price
              obj.insurance_car_type_id = this.category[i].id
              
              this.$http.post('/api/v1/insurance/pricelist', obj)
              .then((resp)=>{
                this.$store.dispatch('triggerAlert', [true, [`Harga sparepart telah berhasil ditambahkan`]]);
                this.$emit('addSuccess');
                this.$emit('closeModal');
                this.category[i].price = 0
              })
              .catch((err)=>{
              //   console.log(err);
                console.log(err.response.data.data.name);
                if (err.response.data.data.name == 'UniqueViolationError') {
                  this.$store.dispatch('triggerAlert', [false, ['Suku cadang sudah ada / telah dibuat.']]);
                } else {
                  this.$store.dispatch('triggerAlert', [false, ['An Error has occured']]);
                }
              })
            }
            
          }
        },
      }
    }
  </script>
  
  <style scoped>
  
  /* ==========================================================================
  #FORM made by Colorlib (https://colorlib.com)
  ========================================================================== */
  input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
  }
  
  .input--style-4 {
    line-height: 50px;
    background: #fafafa;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    color: #666;
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  
  .input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #666;
  }
  
  .input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #666;
    opacity: 1;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #666;
  }
  
  .input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #666;
  }
  
  .label {
    font-size: 16px;
    color: #555;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
  }
  
  .radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  .radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }
  
  .radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
  }
  
  .radio-container input:checked ~ .checkmark:after {
    display: block;
  }
  
  .radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
  }
  
  .checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }
  
  .input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding:20px;
  }
  
  .input-group-icon {
    position: relative;
  }
  
  .input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
  }
  
  /* ==========================================================================
      #TITLE made by Colorlib (https://colorlib.com)
      ========================================================================== */
  .title {
    font-size: 40px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
  }
  </style>
  